export const APP_DOWNLOAD_NUDGE_SESSION_SHOWN =
  "retailer_mobile-app-download-nudge-session-shown";
